import { FileHandle } from "src/app/shared/directives/file-drop.directive";

export class UpdateOrderWithoutInvoiceDto {
  orderId: number;
  finalityId: number;

}


export class UpdateOrderWithInvoiceDto {
  orderId: number;
  finalityId: number;
  files: FileHandle[];
  dueNumber: string;
  dueProtocol: string;

}
